export default {
  bg: require('../assets/images/MasaiFamily.jpg'),
  bg2: require('../assets/images/MasaiSunset.jpg'),
  dashboard: require('../assets/images/undraw_dashboard_nklg.png'),
  campaign: require('../assets/images/undraw_circles_y7s2.png'),
  logo: require('../assets/images/baotree-logo.png'),
  project: require('../assets/images/undraw_project_completed_w0oq.png'),
  404: require('../assets/images/404.svg'),
  noData: require('../assets/images/no-data.png'),
  notFound: require('../assets/images/not_found.png'),
  landingPage1: require('../assets/images/undraw_happy_announcement_ac67.png'),
  landingPage3: require('../assets/images/undraw_active_options_8je6.png'),
  landingPage2: require('../assets/images/undraw_message_sent_1030.png'),
  scooterIcon: require('../assets/images/scooter.svg'),
  shopIcon: require('../assets/images/shop.svg'),
  userIcon: require('../assets/images/user.svg'),
  speakerIcon: require('../assets/images/speaker.svg'),
  addFolderIcon: require('../assets/images/add-folder.svg'),
  doneIllustration: require('../assets/images/undraw_done_a34v.png'),
  empty: require('../assets/images/empty.webp'),
  category1: require('../assets/images/Category 5@2x.svg'),
  category2: require('../assets/images/Category 6@2x.svg'),
  category3: require('../assets/images/Category 8@2x.svg'),
  noImage: require('../assets/images/noImage.png'),
  icon: require('../assets/images/icon.png'),
  logoNoText: require('../assets/images/logo-no-text.png'),
  baotreeHomeBg: require('../assets/images/BAOTREE-HOMEPAGE-V01-1536x1229.png'),
  baotreeHomeBg2: require('../assets/images/Group-24-1536x1229.png'),
  baotreeHomeBg3: require('../assets/images/BAO-TREE_APP-monitoring-and-evaluation-1536x1117.png'),
  baotreeHomeBg4: require('../assets/images/BAO-TREE_APP-collaboration-1536x1117.png'),
  baotreeHomeBg5: require('../assets/images/BAOTREE_APP-all-v02_BAO-TREE_APP-monitoring-and-evaluation-1536x1117.png'),
  baotreeHomeBg6: require('../assets/images/BAOTREE_APP-all-v02_BAO-TREE_APP-task-1536x1117.png'),
  baotreeHomeBg7: require('../assets/images/BAOTREE_ESG-P02-1536x1117.png'),
  baotreeHomeBg8: require('../assets/images/BAOTREE-HOMEPAGE-V01-1536x1229.png'),
  csv: require('../assets/images/icon_file-CSV_plano-512.webp'),
  word: require('../assets/images/word-logo-8.png'),
  excel: require('../assets/images/microsof-excel-logo.png'),
  pdf: require('../assets/images/pdf-icon-png-pdf-zum-download-2.png'),
  powerpoint: require('../assets/images/microsoft-powerpoint-logo.png'),
  noVideo: require('../assets/images/no video.gif'),
  error: require('../assets/images/error.gif'),
  samsungFrame: require('../assets/images/samsung_frame.png'),
  androidPhoneFrame: require('../assets/images/androidphone_bg.jpg'),
  unLogo: require('../assets/images/un_logo.png'),
  verifyEmail: require('../assets/images/verify-email.webp'),
  virtualAssistant: require('../assets/images/virtual-assistant.webp'),
  subscriptionPlan: require('../assets/images/subscription_plan.webp'),
  documentBlank: require('../assets/images/document-blank.webp'),
  mobilePhone: require('../assets/images/mobile-phone.png'),
  // PIA's portrait, background removed. The small variant is for chat-sized
  // avatars, where the full one is six times the bytes for no visible gain.
  piaAvatar: require('../assets/images/pia-avatar.webp'),
  piaAvatarSmall: require('../assets/images/pia-avatar-sm.webp')
}
